/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * Confetti.web.tsx - Shows confetti on the screen
 */

import { useFocusEffect } from '@react-navigation/native';
import { useCallback, useRef } from 'react';
import confetti from 'canvas-confetti';


const Confetti = () => {
  const firstTime = useRef(true);
    
  useFocusEffect(useCallback(() => {
    // Focused

    // Only show the first time.
    if (!firstTime.current) return;
    firstTime.current = false;

    const duration = 15 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = {
      startVelocity: 30, spread: 360, ticks: 60, zIndex: 0
    };
    function randomInRange(min: number, max: number) {
      return Math.random() * (max - min) + min;
    }

    const confettiInterval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        confetti.reset();
        clearInterval(confettiInterval);
      }
  
      const particleCount = 50 * (timeLeft / duration);
      // since particles fall down, start a bit higher than random
      confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
      confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
    }, 250);

    return () => {
      // Unfocused
      confetti.reset();
      clearInterval(confettiInterval);
    };
  }, []));

  return null;
};

export default Confetti;
